import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { loader as monacoLoader } from "@monaco-editor/react";
import * as Sentry from "@sentry/react";

import App from "./App";
import { queryClient } from "./lib/queryClient";
import { initSentry } from "./lib/observability";
import { TopLevelErrorFallback } from "./components/ErrorBoundaryFallbacks";
import { Toaster } from "./components/ui/sonner";
import "./index.css";

// Initialize Sentry BEFORE any other module-load side effects (Monaco loader,
// React root) so the SDK can patch fetch + window error handlers first. No-op
// when VITE_SENTRY_DSN isn't set (local dev).
initSentry();

// Point @monaco-editor/loader at the vendor bundle under frontend/public/monaco-v3/
// so the candidate's code-question page doesn't reach for jsdelivr at runtime —
// same EU-residency rationale as the Pyodide vendoring under /pyodide-0.27.5/.
// Immutable-cached by URL: when you refresh the vendored Monaco bytes, rename the
// dir AND bump the version, or stale bytes are served forever.
monacoLoader.config({ paths: { vs: "/monaco-v3/vs" } });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<TopLevelErrorFallback />} showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
      {/* Sonner toasts (MVP 2.0 #4 surfaced the first usage). Lives outside
          the BrowserRouter so toasts persist across route navigation. */}
      <Toaster />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
